import React, { useEffect, useState } from "react";
import { MAINTENANCE_STATUSES } from "../../constants/maintenanceCategories";
import "./FMSDashboard.css";

export default function FMSDashboard() {
  const [issues, setIssues] = useState([]);
  const [error, setError] = useState("");

  const API = process.env.REACT_APP_API_URL;
  const authHeader = { Authorization: `Bearer ${localStorage.getItem("token")}` };

  const loadIssues = async () => {
    try {
      const res = await fetch(`${API}/api/maintenance/fms`, { headers: authHeader });
      if (!res.ok) {
        setError("Failed to load issues");
        return;
      }
      setIssues(await res.json());
    } catch (err) {
      setError("Server error while loading issues");
    }
  };

  useEffect(() => {
    loadIssues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const updateStatus = async (id, status) => {
    await fetch(`${API}/api/maintenance/fms/${id}/status`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...authHeader },
      body: JSON.stringify({ status }),
    });
    loadIssues();
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("adminRole");
    window.location.href = "/admin/login";
  };

  return (
    <div className="fms-shell">
      <div className="fms-header-bar">
        <h1>FMS Dashboard</h1>
        <button className="fms-logout" onClick={logout}>Logout</button>
      </div>
      <p className="fms-sub">All resident-reported maintenance issues</p>

      {error && <p className="fms-error">{error}</p>}

      <div className="fms-list">
        {issues.map((i) => (
          <div className="fms-item" key={i.id}>
            <div className="fms-item-header">
              <span className="fms-item-category">{i.category}</span>
              <span className="fms-item-location">{i.tower} · {i.unitNumber}</span>
            </div>
            <div className="fms-item-desc">{i.description}</div>
            <div className="fms-item-meta">
              Reported by {i.residentName} ({i.residentEmail}) on {new Date(i.createdAt).toLocaleString()}
            </div>
            {i.acknowledgedBy && (
              <div className="fms-item-meta">
                Acknowledged by {i.acknowledgedBy.name} on {new Date(i.acknowledgedBy.at).toLocaleString()}
              </div>
            )}

            <div className="fms-status-row">
              <span>Status:</span>
              <select
                value={i.status}
                onChange={(e) => updateStatus(i.id, e.target.value)}
                className="fms-status-select"
              >
                {MAINTENANCE_STATUSES.map((s) => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </select>
            </div>
          </div>
        ))}

        {issues.length === 0 && !error && (
          <p className="fms-empty">No issues reported yet</p>
        )}
      </div>
    </div>
  );
}